{
  "version": 1,
  "asset_id": "c65a71c7-ae51-4952-9881-8860fefb5214",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/c65a71c7-ae51-4952-9881-8860fefb5214/hardware-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/c65a71c7-ae51-4952-9881-8860fefb5214/hardware-hero.webp",
  "original_filename": "hardware-hero.webp",
  "size": 135366,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:32Z"
}
